import apiHelper from '../utils/apiHelper';

class WGParticipationService {
    constructor() {
        this.baseUrl = process.env.REACT_APP_API_URL;
    }

    // Get all WG participation stats
    async getWGParticipationStats() {
        try {
            const headers = await apiHelper.getHeaders('graph/wgparticipation');
            const response = await fetch(`${this.baseUrl}/api/graph/wgparticipation`, {
                method: 'GET',
                headers: headers
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching WG participation stats:', error);
            throw error;
        }
    }

    // Update a specific WG participation stat
    async updateWGParticipationStat(id, statData, updatedBy = 'Admin') {
        try {
            const headers = await apiHelper.getHeaders('graph/updateWGParticipation');
            
            const payload = {
                Title: statData.Title,
                value: statData.value,
                icon: statData.icon,
                color: statData.color,
                Publish: statData.Publish,
                updatedBy: updatedBy
            };

            const response = await fetch(`${this.baseUrl}/api/graph/updateWGParticipation/${id}`, {
                method: 'PUT',
                headers: headers,
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to update WG participation stat: ${response.status} - ${errorText}`);
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error('Error updating WG participation stat:', error);
            throw error;
        }
    }
}

export const wgParticipationService = new WGParticipationService(); 